export default __webpack_public_path__ + "static/media/gd.caca105b.jpg";